/// <reference types="datatables.net" />

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { plot } from 'plotly.js-dist-min';
import { Subject } from 'rxjs';
import { Panel1OperativoI } from 'src/app/modelos/operativo/Panel1Operativo';
import { Panel2OperativoI } from 'src/app/modelos/operativo/Panel2Operativo';
import { Panel3DescargaI } from 'src/app/modelos/Panel3DescargaOperativo';
import { Panel3OperativoI } from 'src/app/modelos/operativo/Panel3Operativo';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { AnalisisService } from '../../servicios/analisis/analisis.service';
import { ControloperativoService } from 'src/app/servicios/operativo/controloperativo.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
declare var Plotly: any;
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-operativofivitrimestral',
  templateUrl: './operativofivitrimestral.component.html',
  styleUrls: ['./operativofivitrimestral.component.css']
})
export class OperativofivitrimestralComponent implements OnDestroy,OnInit {

  data: any;
  layout: any = {
    barmode: 'group',
    xaxis: {fixedrange: true},
    yaxis: {fixedrange: true}
  };
  options: any = {
    displayModeBar: false,
    displaylogo: false,
    autosize:false
  };
  config: any = {
    responsive: true
  };

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  ListaPeriodosConsultar:PeriodoReporteFiviI[];
  DatosPanel1: Panel1OperativoI = new Panel1OperativoI;
  DatosPanel2: Panel2OperativoI = new Panel2OperativoI;
  DatosPanel3: Panel3OperativoI[];

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService,
    private operativoService:ControloperativoService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Inicio",
              "last": "Fin",
              "next": "Sig.",
              "previous": "Ant."
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "_START_ a _END_ de _TOTAL_"
        }
    };
    this.analisisService.consultarPeriodoActivoFIVI().subscribe(Result=>{
      this.anioConsulta = Number(Result.anio);
      //this.consucutivoConsulta = Number(Result.consecutivoPeriodo);
      this.PeriodoSeleccionado = Result;
      if(Number(Result.consecutivoPeriodo)>=1&&Number(Result.consecutivoPeriodo)<=3){
        this.consucutivoConsulta = 1;
        this.CosultarDatos();
      }
      if(Number(Result.consecutivoPeriodo)>=4&&Number(Result.consecutivoPeriodo)<=6){
        this.consucutivoConsulta = 2;
        this.CosultarDatos();
      }
      if(Number(Result.consecutivoPeriodo)>=7&&Number(Result.consecutivoPeriodo)<=8){
        this.consucutivoConsulta = 3;
        this.CosultarDatos();
      }
      if(Number(Result.consecutivoPeriodo)>=9&&Number(Result.consecutivoPeriodo)<=12){
        this.consucutivoConsulta = 4;
        this.CosultarDatos();
      }
      /*this.operativoService.controlOperativoFiviTrimestral(this.consucutivoConsulta, this.anioConsulta).subscribe(datos=>{
        this.DatosPanel1 = datos.panel1;
        this.DatosPanel2 = datos.panel2;
        var trace1 = {
          y: ['Pendientes','En proceso','En cargue','Cargadas','Aprobado','Reproceso','Directorio'],
          x: [datos.panel2.porcenPendiente,datos.panel2.porcenEnproceso,datos.panel2.porcenEncargue,datos.panel2.porcenCargado,datos.panel2.porcenAprobado,datos.panel2.porcenReproceso,0],
          name: '%',
          type: 'bar',
          orientation: 'h'
        };
        var trace2 = {
          y: ['Pendientes','En proceso','En cargue','Cargadas','Aprobado','Reproceso','Directorio'],
          x: [datos.panel2.numPendientes,datos.panel2.numEnproceso,datos.panel2.numEncargue,datos.panel2.numCargado,datos.panel2.numAprobado,datos.panel2.numReproceso,datos.panel2.totalFuentes],
          name: '#',
          type: 'bar',
          orientation: 'h'
        };
        this.data = [trace1, trace2];
        Plotly.newPlot('myPlotlyDiv', this.data, this.layout, this.options, this.config);
        this.DatosPanel3 = datos.panel3;
        this.dtTrigger.next();
      });*/
    });
    this.api.listaPeriodosCalendarioFivi().subscribe(Result4=>{
      this.ListaPeriodosConsultar = Result4;
    });
    this.analisisService.getListaAniosVigenciaFivi().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarOperativo(){
    this.router.navigate(['operativo']);
  }

  peridoPorAnioMes(){
    this.analisisService.periodoFiviPorAnioMes(this.anioConsulta,this.consucutivoConsulta).subscribe(respuesta2=>{
      this.PeriodoSeleccionado = respuesta2;
      //this.CosultarListaEstados(respuesta2.id);
    });
  }

  CosultarDatos(){
    this.operativoService.controlOperativoFiviTrimestral(this.consucutivoConsulta, this.anioConsulta).subscribe(datos=>{
      this.DatosPanel1 = datos.panel1;
      this.DatosPanel2 = datos.panel2;
      var trace1 = {
        y: ['Pendientes','En proceso','En cargue','Cargadas','Aprobado','Reproceso','Directorio'],
        x: [datos.panel2.porcenPendiente,datos.panel2.porcenEnproceso,datos.panel2.porcenEncargue,datos.panel2.porcenCargado,datos.panel2.porcenAprobado,datos.panel2.porcenReproceso,0],
        name: '%',
        type: 'bar',
        orientation: 'h'
      };
      var trace2 = {
        y: ['Pendientes','En proceso','En cargue','Cargadas','Aprobado','Reproceso','Directorio'],
        x: [datos.panel2.numPendientes,datos.panel2.numEnproceso,datos.panel2.numEncargue,datos.panel2.numCargado,datos.panel2.numAprobado,datos.panel2.numReproceso,datos.panel2.totalFuentes],
        name: '#',
        type: 'bar',
        orientation: 'h'
      };
      this.data = [trace1, trace2];
      Plotly.newPlot('myPlotlyDiv', this.data, this.layout, this.options, this.config);

      this.DatosPanel3 = datos.panel3;
      this.dtTrigger.next();
    });
  }

  CosultarDatos2(){
    this.operativoService.controlOperativoFiviTrimestral(this.consucutivoConsulta, this.anioConsulta).subscribe(datos=>{
      this.DatosPanel1 = datos.panel1;
      this.DatosPanel2 = datos.panel2;
      var trace1 = {
        y: ['Pendientes','En proceso','En cargue','Cargadas','Aprobado','Reproceso','Directorio'],
        x: [datos.panel2.porcenPendiente,datos.panel2.porcenEnproceso,datos.panel2.porcenEncargue,datos.panel2.porcenCargado,datos.panel2.porcenAprobado,datos.panel2.porcenReproceso,0],
        name: '%',
        type: 'bar',
        orientation: 'h'
      };
      var trace2 = {
        y: ['Pendientes','En proceso','En cargue','Cargadas','Aprobado','Reproceso','Directorio'],
        x: [datos.panel2.numPendientes,datos.panel2.numEnproceso,datos.panel2.numEncargue,datos.panel2.numCargado,datos.panel2.numAprobado,datos.panel2.numReproceso,datos.panel2.totalFuentes],
        name: '#',
        type: 'bar',
        orientation: 'h'
      };
      this.data = [trace1, trace2];
      Plotly.newPlot('myPlotlyDiv', this.data, this.layout, this.options, this.config);

      this.DatosPanel3 = datos.panel3;
      this.reinicializarDataTable();
    });
  }

  reinicializarDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  exportarExcel(){
    let titulosColumas = ["Código entidad", "Razón social", "Estado información"];
    let base64 = this.appService.generateExcelBase64ControlOperatioPanel3(titulosColumas, this.DatosPanel3);
    let nombreArch = "Tabla fuentes "+this.anioConsulta+" - "+this.consucutivoConsulta+".xlsx";

    this.descargarArchivo(base64, nombreArch);
  }

  descargarArchivo(stringBase64, nombreArchivo) {
    if (stringBase64) {
      const blob = this.base64toBlob(stringBase64);
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = nombreArchivo;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
  }

  base64toBlob(base64Data: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

}
